export default __webpack_public_path__ + "static/media/1.cfec91b6.png";